import { CheckFilledIcon, ErrorFillIcon, InfoFilledIcon, WarningFillIcon } from '../../../foundations';

import type { ReactElement } from 'react';

import type { SlotNames } from '../../../../utils/types/slots.types';
import type { ToastType } from './toast.types';

export const toastSlotNames = ['Description', 'ActionsContainer'] as SlotNames[];

export const iconMapping: {
  [key in ToastType]: ReactElement;
} = {
  error: <ErrorFillIcon />,
  info: <InfoFilledIcon />,
  success: <CheckFilledIcon />,
  warning: <WarningFillIcon />,
};
